import React, { Dispatch, SetStateAction } from 'react';

export default function useValidatedState<T>(
  initialValue: T,
  validator: (val: T) => boolean
): [T, Dispatch<SetStateAction<T>>, boolean] {
  const [state, setState] = React.useState(initialValue);

  const isValid = validator(state);

  return [state, setState, isValid];
}
